import React, {useContext, useState} from "react";
import NumericInput from 'react-numeric-input';

import QuoteContext from "../../../quote-context";

const EditSuperPackage = ({superPackage, hide, height}) => {

	const {formDispatcher} = useContext(QuoteContext);

	const[data, setData] = useState({
		pax: superPackage.pax,
	})

	const handleSubmit = (e)=> {
		e.preventDefault();
		formDispatcher({
			type:"EDIT_SUPER_PACKAGE",
			id: superPackage.id,
			pax: data.pax,
            nights: superPackage.nights,
		});
		hide();
	}

	return (
		<div className="modal-content" style={{minHeight: height }}>
			<div className="pd">
				<div className="bg-light-blue pd radius">
					<div className="full-width-block">
						<div className="row no-padding">
							<div className="column">
								<div className="align-content vertical center mg-b">
									<span className="icon icon-edit medium black left"></span>
									<h4 className="no-mg-b">Editing {superPackage.name}</h4>
								</div>
							</div>
						</div>
					</div>
					<div className="full-width-block mg-b">
						<div className="row no-padding align-content horizontal left">
							<div className="column one-fifth mg-b-tch-sm">
								<span>Guests</span>
							</div>
					

							<div className="column one-third">
								<NumericInput min={3} max={50} value={data.pax} mobile={true} onChange={value => setData({...data, pax: value})}/>
							</div>
						</div>
					</div>
					<div className="full-width-block">
						<div className="row no-padding">
							<div className="column">
								<div className="align-content vertical center">
									<button className="button secondary small transparent radius fit-content mg-r" onClick={hide}>Cancel edit</button>
									<button className="button secondary small radius fit-content" onClick={handleSubmit}>Confirm changes</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default EditSuperPackage;
